import { ApiOptions } from '@csp/csp-common-model';
import { JwtRestServiceV1 } from '@csp/dmdp-api-client';
import { toRestOptions } from '../util/toRestOptions';
import { DmdpTokenService } from './DmdpTokenService';

const revokeToken = async (apiOptions?: ApiOptions): Promise<void> => {
  if (DmdpTokenService.getToken()) {
    await JwtRestServiceV1.revokeMyCurrentToken(toRestOptions(apiOptions));
  }
};

export const DmdpAuthService = {
  revokeToken,
};
